import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class GiftResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("GiftResourcePackage");
    }
    public get assets_views_gift_emittor_emitter_confety_json(): Object {
        return this.resource<Object>("assets/views/gift/emittor/emitter_confety.json");
    }
    public get assets_views_gift_ui_ui_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/gift/ui/ui_1x.atlas.json");
    }
    public get assets_views_gift_ui_light_glow_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["light_glow.png"];
    }
    public get assets_views_gift_ui_gift_dice_rolls_background_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["gift_dice_rolls/background.png"];
    }
    public get assets_views_gift_ui_gift_dice_rolls_glow_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["gift_dice_rolls/glow.png"];
    }
    public get assets_views_gift_ui_bottom_glow_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["bottom_glow.png"];
    }
    public get assets_views_gift_ui_gift_dice_rolls_won_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["gift_dice_rolls/won.png"];
    }
    public get assets_views_gift_ui_gift_box_cover_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["gift_box_cover.png"];
    }
    public get assets_views_gift_ui_gift_box_base_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["gift_box_base.png"];
    }
    public get assets_views_gift_ui_gift_box_glow_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["gift_box_glow.png"];
    }
    public get assets_views_gift_ui_shields_shield_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["shields/shield.png"];
    }
    public get assets_views_gift_ui_gift_dice_rolls_dice_icon_png(): Texture {
        return this.assets_views_gift_ui_ui_1x_atlas_json.textures["gift_dice_rolls/dice_icon.png"];
    }
    public get assets_views_gift_ui_ui_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/gift/ui/ui_1x.atlas.png");
    }
}

